var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"ylAboutHistory"}},[(_vm.isMobileScreen)?_c('ylAboutHistoryMobile',{attrs:{"list":_vm.list}}):_c('ylAboutHistoryPC',{attrs:{"list":_vm.list}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }